var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ui-social",class:_vm.classes},[_c('icon-' + _vm.type,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }